import React from 'react'
import { Link } from 'react-router-dom'
import { fixedAssets } from 'src/containers/PreCache'
import styled from 'styled-components'
import routes from '../routes'
import { SIZES } from '../styles/theme'


const Page = styled.div`
  position: fixed;
  max-height: 100%;
  text-align: center;
  color: white;
  right: 0;
  bottom: 0;
  min-width: 100%;
  min-height: 100%;
  background: url(${fixedAssets.entranceBg});
  background-size: cover;
  background-position: center;

  #myVideo {
    position: fixed;
    right: 0;
    bottom: 0;
    min-width: 100%;
    max-width: 100%;
    min-height: 100%;
    object-fit: cover;
  }
  .mobile-show {
    display: none;
    height: 50vh;
    top: -25%;
    object-fit: scale-down;
  }
  .titleImage {
    position: fixed;
    top: 0%;
    left: 0%;
  }
  .visual {
    position: fixed;
    width: 15%;
  }
  #growth {
    top: 35%;
    left: 2%;
    animation: growthRotate 4s forwards;
  }
  #comfort {
    top: 40%;
    left: 83%;
    animation: comfortRotate 4s forwards;
  }
  #cognition {
    top: 80%;
    left: 47%;
    animation: cognitionRotate 4s forwards;
  }
  #spacerock {
    top: 100%;
    left: 100%;
    width: 25%;
    animation: rockEnter 4s forwards;
  }
  #playBtn {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    span {
      font-weight: 700;
      color: #fff;
      font-size: 16px;
      padding: 10px 18px;
      border-radius: 6px;
      display: block;
      background: #FA7F25;
      cursor: pointer;
      transition: all 300ms;
    }
    &:hover {
      text-decoration: none;
      span {
        color: #000;
        padding: 10px 28px;
      }
    }
  }

  ${SIZES.mobile} {
    #myVideo {
      display: none;
    }
    .mobile-show {
      display: block;
    }
    .visual {
      width: 30%;
    }
  }

`

export default function WelcomePage() {
  return (
    <Page>
      <Link to={routes.login} id="playBtn">
        <span>Enter Conference</span>
      </Link>
      <img width="100%" src={fixedAssets.kvTitleM} alt="event-banner" className="titleImage d-md-none d-block mx-auto" />
      <img width="100%" src={fixedAssets.kvTitle} alt="event-banner" className="titleImage d-none d-md-block mx-auto" />
    </Page>
  )
}
